// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class BMHistoryRequestMessage extends PFixMessage {
    constructor(fieldSet) {
        super(Message.BM_HISTORY_REQUEST, fieldSet);
    }
    setUserID(id) {
        this.setFieldValue(FieldsFactory.FIELD_USER_ID, id);
    }
}
